import { render } from "./sign-in-page.vue?vue&type=template&id=1aab8b64"
import script from "./sign-in-page.vue?vue&type=script&lang=js"
export * from "./sign-in-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__